export default {
  background_image: 'Imagine de fundal',
  file_too_large: 'Fișierul este prea mare. Dimensiunea maximă este de {{max}} MB.',
  upload_failed: 'Încărcarea a eșuat. Încercați din nou.',
};
